import { Typography } from "PFComponents/typography";
import React, { JSX } from "react";
import { useTranslation } from "react-i18next";

import { CalendarMode } from "../../../../types";
import { WorkforceCalendarData } from "../../context/booking_overview_context.types";
import { useBookingsOverviewContext } from "../../context/bookings_overview_context";
import css from "./entries_counter.module.scss";

export const EntriesCounter = (): JSX.Element => {
  const { t } = useTranslation("bookingModule");

  const {
    calendarData: { data },
    calendarMode
  } = useBookingsOverviewContext<WorkforceCalendarData>();

  const counterTranslationKey =
    calendarMode === CalendarMode.Workforce ? "profilesCounter" : "projectsCounter";
  const count =
    calendarMode === CalendarMode.Workforce
      ? data.meta.counters?.filtered_profiles_count
      : data.meta.counters?.filtered_activities_count;
  const counterMessage = t(counterTranslationKey, { count: count ?? 0 });

  return (
    <Typography variant="labelRegular" className={css.root} clipOverflow>
      {counterMessage}
    </Typography>
  );
};
